module.exports = __webpack_public_path__ + "static/media/BR-white-small.f226b03a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/BR-white-small.svg
// module id = 4024
// module chunks = 0